import { StanDataRowHeaderProps } from './StanDataRow.types';
import styles from './StanDataRow.module.css';
import { cn } from '@/lib/utils/cn';
import { calculateActionsWidth, hasActionsInChildren } from './StanDataRow.logic';
import { StanTooltip } from '../StanTooltip/StanTooltip';

export const StanDataRowHeader: React.FC<StanDataRowHeaderProps> = ({
    columns,
    gridTemplate,
    className,
    actionButtonCount = 0,
    children,
}) => {
    // Auto-detect if we need actions space by checking if any sibling rows have actions
    const shouldShowActionsSpace = actionButtonCount > 0 || (children && hasActionsInChildren(children));

    // Calculate the width needed for actions
    const actionsWidth = calculateActionsWidth(actionButtonCount);

    return (
        <div className={cn(className, styles['stan-data-row-header'])}>
            {/* Header content area - contains all column headers */}
            <div
                className={styles['header-content']}
                style={{
                    gridTemplateColumns: gridTemplate,
                }}
            >
                {columns.map((column, index) => (
                    <div
                        key={column.id || column.name || `header-${index}`}
                        className={cn(styles.column, column.className)}
                    >
                        {column.helperText ? (
                            <StanTooltip
                                content={column.helperText}
                                trigger='click'
                                position='top'
                                showIcon
                                iconPosition='right'
                            >
                                <span className={styles['header-with-tooltip']}>
                                    {column.value ? column.value : column.name}
                                </span>
                            </StanTooltip>
                        ) : (
                            <span>{column.value ? column.value : column.name}</span>
                        )}
                    </div>
                ))}
            </div>

            {/* Actions space - invisible but reserves the exact space actions will take */}
            {shouldShowActionsSpace && (
                <div
                    className={styles['header-actions-space']}
                    style={{ width: actionsWidth > 0 ? `${actionsWidth}px` : 'auto' }}
                />
            )}
        </div>
    );
};

StanDataRowHeader.displayName = 'StanDataRowHeader';
